export default __webpack_public_path__ + "static/media/want-you-feat-sara-skinner-1586956276-s4lOrfrHQj.c73eef0d.jpg";